import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import correcoesService, { CorrecaoResponse } from "../../../api/correcoes";
import {
  RelatorioNotasDaTurmaNotaResponse,
  RelatorioNotasDaTurmaResponse,
} from "../../../api/relatorios";
import { errorToString } from "../../../helpers/funcoes";
import { formatarNota } from "./CelulaNota";

export function ModalExclusao(props: {
  relatorio: RelatorioNotasDaTurmaResponse;
  nota?: RelatorioNotasDaTurmaNotaResponse;
  onClose: () => void;
  onError: (error: string) => void;
  onRefresh: () => void;
}) {
  const [loading, setLoading] = useState(false);
  const [correcoes, setCorrecoes] = useState<CorrecaoResponse[]>([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  const nota = props.nota;

  useEffect(() => {
    setLoading(true);
    Promise.all(
      nota?.correcoes.map((x) => correcoesService.getById(x.id)) ?? []
    )
      .then((res) => {
        setCorrecoes(res);
        setSelectedItems(res.map((x) => x.id));
      })
      .catch((err) => props.onError(errorToString(err)))
      .finally(() => setLoading(false));
    return () => setCorrecoes([]);
  }, [nota?.correcoes.map((x) => x.id).join("-")]);

  let atividadeNome = "";
  let alunoNome = "";

  if (nota) {
    alunoNome =
      props.relatorio.alunos.find((x) => x.id == nota.alunoId)?.nome ?? "";
    atividadeNome =
      props.relatorio.atividades.find((x) => x.id == nota.atividadeId)?.nome ??
      "";
  }

  const onConfirmarClick = () => {
    setLoading(true);
    Promise.all(selectedItems.map((x) => correcoesService.deleteById(x)))
      .then(() => {
        props.onClose();
        props.onRefresh();
      })
      .catch((err) => props.onError(errorToString(err)));
  };

  const toggleCheckbox = (id: string) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((x) => x != id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  return (
    <Modal centered isOpen={!!nota} toggle={props.onClose} size="lg">
      <ModalHeader toggle={props.onClose}>Excluir Correção</ModalHeader>
      <ModalBody>
        {loading ? (
          <Spinner />
        ) : (
          <div>
            <div className="pb-3">
              <span className="fw-bold">Aluno:</span> {alunoNome}
              <br />
              <span className="fw-bold">Atividade</span>: {atividadeNome}
            </div>
            {correcoes.map((c) => (
              <div key={c.id} className="d-flex pb-3">
                <div className="pe-2">
                  <Input
                    type="checkbox"
                    checked={selectedItems.includes(c.id)}
                    onClick={() => toggleCheckbox(c.id)}
                  />
                </div>
                <div>
                  <span className="fw-bold">Página:</span> {c.pageIndex + 1}{" "}
                  &ndash; <span className="fw-bold">Nota:</span>{" "}
                  {formatarNota(c.nota)}
                </div>
              </div>
            ))}
          </div>
        )}
      </ModalBody>
      {correcoes.length > 0 && (
        <ModalFooter>
          <Button
            color="primary"
            disabled={selectedItems.length == 0}
            onClick={onConfirmarClick}
          >
            Confirmar
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
}
